import React from "react"

import AnswerSelect from "./AnswerSelect"
import AnswerButton from "../../components/AnswerButton"
import type { Answer, Question as QuestionType } from "../types"

import Typography from "@components/elements/V2/Typography"
import { Color } from "@constants/V2/color"

interface QuestionProps {
  currentQuestionNumber: number
  totalQuestions: number
  question: QuestionType
  multiselectedAnswers: Answer[]
  onAnswer: (answers: Answer[]) => void
  onMultiselect: (answer: Answer) => void
}

const Question = ({
  currentQuestionNumber,
  totalQuestions,
  question,
  multiselectedAnswers,
  onAnswer,
  onMultiselect,
}: QuestionProps) => {
  return (
    <div className="mx-auto flex flex-col items-center px-20 pt-[50px] text-center sm:px-0">
      <Typography
        text={`Question ${currentQuestionNumber} of ${totalQuestions}`}
        font="grotesk"
        weight="medium"
        size="body-md"
        color={Color.Black}
        className="mb-16"
      />

      <Typography
        text={question.question}
        font="grotesk"
        weight="medium"
        size="lead-lg"
        color={Color.Black}
        className="mb-10"
      />

      <Typography
        text={question.description}
        font="grotesk"
        weight="book"
        size="body-md"
        color={Color.Black}
        className="mb-60 opacity-50"
      />

      <div className="flex w-full max-w-[500px] flex-col gap-10 sm:gap-[22px]">
        {question.options.map((option) => {
          if (question.multipleAnswers) {
            return (
              <AnswerSelect
                key={option.answer}
                text={option.answer}
                description={option.description}
                active={
                  !!multiselectedAnswers.some((a) => a.answer === option.answer)
                }
                onClick={() => {
                  onMultiselect(option)
                }}
              />
            )
          }

          return (
            <AnswerButton
              key={option.answer}
              text={option.answer}
              description={option.description}
              onClick={() => {
                onAnswer([option])
              }}
            />
          )
        })}
      </div>
    </div>
  )
}

export default Question
